import { CATALOG_LOADING, GET_CATALOG, GET_CATALOG_SUCCESS, GET_CATALOG_FAIL, ADD_CATALOG_SUCCESS, ADD_CATALOG_FAIL, DELETE_CATALOG_SUCCESS, DELETE_CATALOG_FAIL, UPDATE_CATALOG_SUCCESS, UPDATE_CATALOG_FAIL, CATALOG_RESET, CATALOG_RESET_CREATE, GET_CATALOG_ONE, GET_CATALOG_AVAILABLE_ONE } from "./actionType";

const INIT_STATE = {
  catalogs: [],
  catalog: null,
  catalogAvailable: [],
  catalogAdded: {},
  error: false,
  isCatalogCreated: false,
  isCatalogSuccess: false,
  loading: false,
};

const Catalog = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CATALOG_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CATALOG:
          return {
            ...state,
            catalogs: action.payload.data,
            isCatalogCreated: false,
            isCatalogSuccess: true,
            loading: false,
          };

        case GET_CATALOG_ONE:
          return {
            ...state,
            catalog: action.payload.data,
            isCatalogSuccess: true,
            loading: false,
          };

        case GET_CATALOG_AVAILABLE_ONE:
          return {
            ...state,
            catalogAvailable: action.payload.data,
            isCatalogSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }

    case GET_CATALOG_FAIL:
      return {
        ...state,
        error: true,
        isCatalogCreated: false,
        isCatalogSuccess: false,
        loading: false,
      };

    case GET_CATALOG: {
      return {
        ...state,
        isCatalogCreated: false,
        loading: true,
      };
    }

    case GET_CATALOG_ONE: {
      return {
        ...state,
        isCatalogCreated: false,
        loading: true,
      };
    }

    case GET_CATALOG_AVAILABLE_ONE: {
      return {
        ...state,
        isCatalogCreated: false,
        loading: true,
      };
    }

    case CATALOG_LOADING: {
      return {
        ...state,
        isCatalogCreated: false,
        loading: true,
      };
    }

    case ADD_CATALOG_SUCCESS:
      return {
        ...state,
        isCatalogCreated: true,
        loading: false,
        catalogs: [action.payload.data, ...state.catalogs],
        catalogAdded: action.payload.data,
      };

    case ADD_CATALOG_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        catalogs: state.catalogs.filter((catalog) => catalog.id.toString() !== action.payload.id.toString()),
      };

    case DELETE_CATALOG_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        catalogs: state.catalogs.map((catalog) => (catalog.id.toString() === action.payload.data.id.toString() ? { ...catalog, ...action.payload.data } : catalog)),
      };

    case UPDATE_CATALOG_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CATALOG_RESET_CREATE:
      return {
        ...state,
        isCatalogCreated: false,
      };

    case CATALOG_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Catalog;
